import angular from 'angular';
import Logger from '../../../shared/logger';

export const SearchService = (Restangular) => {
    const getCandidateSearch = function (body) {
        return Restangular.all('candidate')
            .all('search')
            .post(body)
            .catch(error => Logger.error(error))
    };

    return {
        getCandidateSearch,
    };
};

angular.module('TALENYA-FE')
    .factory('SearchService', SearchService);

